import { createAction } from '@reduxjs/toolkit';

import type { IncomingCaptionLine } from './types';

export const captionsActions = {
  rttRequested: createAction('[Captions] rtt requested'),
  rttStopped: createAction('[Captions] rtt stopped'),
  captionsFailed: createAction('[Captions] captions failed to start'),
  captionsShown: createAction<boolean>('[Captions] captions shown'),
  captionLineReceived: createAction<IncomingCaptionLine>('[Captions] caption line received'),
  cleared: createAction('[Captions] cleared'),
};
